import { render, staticRenderFns } from "./RegisterNewUserMenu.vue?vue&type=template&id=82702556&"
import script from "./RegisterNewUserMenu.vue?vue&type=script&lang=ts&"
export * from "./RegisterNewUserMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports